import Login from './pages/login';

export default [...Login.Routes];
